module.exports = __webpack_public_path__ + "5bf550d0b1fdc01638df584f3f7c9749.svg";